import { ServerApiVersion } from 'features/identificationVisits/types'

import { useRequestMutation } from './base'

export function useIdentificationEventsExport(version: ServerApiVersion) {
  const v3 = useRequestMutation('idEventsExportV3')
  const v4 = useRequestMutation('idEventsExportV4')

  switch (version) {
    case ServerApiVersion.V3:
      return v3
    case ServerApiVersion.V4:
    default:
      return v4
  }
}
